/**
 * Countdown timer block (blocks/jsc-countdown.liquid).
 *
 * The end date/time lives in Theme Settings as plain UK wall-clock values
 * (Shopify theme settings have no native date/time input type). Visitors
 * load this from anywhere in the world, so a naive `new Date('YYYY-MM-DDTHH:MM')`
 * would count down to that wall-clock time in the VISITOR's own timezone
 * instead of the UK's — wrong by however many hours they're offset. To land
 * on the same real-world instant for everyone, the entered value is treated
 * as Europe/London local time and converted to the equivalent UTC instant
 * via Intl, which also keeps the correct BST/GMT offset for whatever time of
 * year the end date falls in (no offset hardcoded).
 */
(function () {
  var LONDON_TIME_ZONE = 'Europe/London';

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function londonWallClockToUtcDate(dateStr, timeStr) {
    if (!dateStr || !timeStr) return null;

    var dateParts = dateStr.split('-').map(Number);
    var timeParts = timeStr.split(':').map(Number);
    if (dateParts.length !== 3 || timeParts.length < 2) return null;

    var year = dateParts[0];
    var month = dateParts[1];
    var day = dateParts[2];
    var hour = timeParts[0];
    var minute = timeParts[1];

    // Guess: treat the wall-clock values as if they were already UTC.
    var guessUtcMs = Date.UTC(year, month - 1, day, hour, minute, 0);

    // See what that guessed instant actually reads as in Europe/London —
    // the gap between the two is the UTC offset to correct for.
    var formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: LONDON_TIME_ZONE,
      hourCycle: 'h23',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
    var parts = {};
    formatter.formatToParts(new Date(guessUtcMs)).forEach(function (part) {
      parts[part.type] = part.value;
    });
    var londonReadingMs = Date.UTC(
      Number(parts.year),
      Number(parts.month) - 1,
      Number(parts.day),
      Number(parts.hour),
      Number(parts.minute),
      Number(parts.second)
    );

    var offsetMs = londonReadingMs - guessUtcMs;
    return new Date(guessUtcMs - offsetMs);
  }

  function renderCountdown(el, endDate) {
    var valueEls = el.querySelectorAll('[data-value]');
    var diffMs = Math.max(0, endDate.getTime() - Date.now());

    var days = Math.floor(diffMs / 86400000);
    var hours = Math.floor((diffMs % 86400000) / 3600000);
    var minutes = Math.floor((diffMs % 3600000) / 60000);
    var seconds = Math.floor((diffMs % 60000) / 1000);

    valueEls[0].textContent = pad(days);
    valueEls[1].textContent = pad(hours);
    valueEls[2].textContent = pad(minutes);
    valueEls[3].textContent = pad(seconds);

    return diffMs <= 0;
  }

  function initCountdown(el) {
    if (el.dataset.jscCountdownInitialized) return;
    el.dataset.jscCountdownInitialized = 'true';

    var endDate = londonWallClockToUtcDate(el.dataset.endDate, el.dataset.endTime);
    if (!endDate) return;

    if (renderCountdown(el, endDate)) return;

    var intervalId = setInterval(function () {
      if (renderCountdown(el, endDate)) {
        clearInterval(intervalId);
      }
    }, 1000);
  }

  function initAll(root) {
    root.querySelectorAll('[data-jsc-countdown]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Theme editor: re-init when this block is added/re-rendered live.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
